"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawCommand = exports.dError = void 0;
var dError = /** @class */ (function (_super) {
    __extends(dError, _super);
    function dError(message) {
        var _this = _super.call(this, message) || this;
        _this.isNotice = true;
        return _this;
    }
    return dError;
}(Error));
exports.dError = dError;
/**
* 描画コマンドクラス
*/
var drawCommand = /** @class */ (function () {
    // -----------------------------------------------
    // Constructors（コンストラクタ）
    // -----------------------------------------------
    /**
    * コンストラクタ
    * @param command コマンド
    * @param params パラメータ
    */
    function drawCommand(command, params) {
        if (params === void 0) { params = []; }
        this.command = command;
        this.params = params;
    }
    Object.defineProperty(drawCommand.prototype, "anchorPoint", {
        // -----------------------------------------------
        // Accessors（外部アクセス用プロパティ）
        // -----------------------------------------------
        /**
        * アンカーポイント
        * @summary ベジェ以外の場合は制御点を返す
        */
        get: function () {
            if (this.command == "c") {
                return this.getPoint(this.params[4], this.params[5]);
            }
            else if (this.command == "h") {
                return null;
            }
            else {
                return this.getPoint(this.params[0], this.params[1]);
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
    * コントロールポイント1
    * @summary 指定値を1点目のアンカーとした際のコントロールポイントを返します。
    * @param a1 アンカーポイント
    * @returns ベジェ以外はnullを返します。
    */
    drawCommand.prototype.getCtrlPt1 = function (a1) {
        if (this.command != "c")
            return null;
        if (this.ptEquals(a1, this.pt(0)))
            return this.pt(1);
        return this.pt(0);
    };
    /**
    * コントロールポイント2
    * @summary 2点目のアンカーにおけるコントロールポイントを返します。
    * @returns ベジェ以外はnullを返します。
    */
    drawCommand.prototype.getCtrlPt2 = function () {
        if (this.command != "c")
            return null;
        if (this.ptEquals(this.pt(2), this.pt(1)))
            return this.pt(0);
        return this.pt(1);
    };
    /**
     * 任意のポイント
     * @param idx パラメータのインデックス(0～2)
     */
    drawCommand.prototype.pt = function (idx) {
        var bidx = 2 * idx;
        if (bidx + 1 >= this.params.length) {
            return null;
        }
        return this.getPoint(this.params[bidx], this.params[bidx + 1]);
    };
    /**
    * クローン
    */
    drawCommand.prototype.clone = function () {
        return new drawCommand(this.command, this.params.concat());
    };
    // -----------------------------------------------
    // Methods（内部関数）
    // -----------------------------------------------
    drawCommand.prototype.getPoint = function (x, y) {
        return { x: x, y: y };
    };
    /**
     * 等価評価
     * @summary 指定されたポイントとこのポイントが一致しているかを評価する
     * @param pt 比較対象ポイント
     * @param allowableDec 小数点以下の桁数(0～20)※toFixedの引数値／省略時(既定値-1)はtoFixedせずにそのまま比較
     * @returns true:一致／false:不一致
     */
    drawCommand.prototype.ptEquals = function (pt1, pt2, allowableDec) {
        if (allowableDec === void 0) { allowableDec = -1; }
        if (allowableDec == -1) {
            return pt1.x == pt2.x && pt1.y == pt2.y;
        }
        return pt1.x.toFixed(allowableDec) == pt2.x.toFixed(allowableDec) && pt1.y.toFixed(allowableDec) == pt2.y.toFixed(allowableDec);
    };
    return drawCommand;
}());
exports.drawCommand = drawCommand;
